import styled, { css } from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const MainSectionContainer = styled.div`
  flex: 1;
  padding: 0 24px;
`;

export const DashboardContainer = styled.div`
  width: 100%;
  padding: 0 16px;
  overflow: visible;
  overflow-x: scroll;
  @media (max-width: 1020px) {
    padding: 0;
  }
`;

export const DashboardHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 12px;
  min-height: 48px;
  margin-bottom: 6px;
  @media (max-width: 1020px) {
    margin-bottom: 12px;
  }
`;

export const DashboardSideSection = styled.div`
  padding: 0 84px 0 16px;
  @media (max-width: 1020px) {
    padding: 0 16px;
  }
`;

export const SearchInputWrapper = styled.div`
  max-width: 284px;
`;

export const PageSection = styled.div<{ disabled?: boolean }>(
  ({ disabled = false }) => css`
    margin: 56px 0;
    opacity: ${disabled && '0.5'};
  `
);

export const HorizontalSectionWrapper = styled.div<{ marginBottom?: string }>(
  ({ marginBottom }) => css`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${marginBottom ? `${marginBottom}` : '16px'};
    gap: 8px;
  `
);

export const OverflowingHorizontalWrapper = styled(HorizontalSectionWrapper)`
  flex-wrap: nowrap;
  @media (max-width: 1020px) {
    width: calc(100% + 16px);
    overflow-x: auto;
    > div {
      flex-wrap: nowrap;
    }
    /* Only show scrollbar when hovering over */
    &:not(:hover) {
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      /* WebKit */
      ::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
    /* Never show scrollbar on touch devices */
    @media (pointer: coarse) {
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      /* WebKit */
      ::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }
`;

export const FilterSectionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  grid-column-gap: 8px;
  grid-row-gap: 16px;
  margin-top: 16px;
`;

export const ScrollBox = styled.div`
  max-height: 20rem;
  min-height: 15rem;
  overflow-y: auto;
  overflow-x: hidden;
`;
